import React from 'react';
import classNames from 'classnames';
import { SkeletonField } from 'components/layout/loading';
import InputError from '../InputError/InputError';
import Toggle from '../Toggle/Toggle';

export default function ToggleField({
  id,
  name,
  label,
  description,
  labelPosition = 'right',
  checked = false,
  onChange,
  errors,
  loading = false,
  disabled = false,
  className = '',
  labelClassName = '',
  toggleClassName = '',
}) {
  if (loading) {
    return <SkeletonField className={className || 'w-full'} />;
  }

  const controlId = id || name;
  const labelId = label ? `${controlId}-label` : undefined;
  const descriptionId = description ? `${controlId}-description` : undefined;
  const error = errors && name ? errors[name] : null;

  const labelContent = (
    <div className="min-w-0">
      {label && (
        <label
          htmlFor={controlId}
          id={labelId}
          className={classNames(
            'block text-sm/6 font-medium text-gray-100',
            disabled ? 'cursor-not-allowed' : 'cursor-pointer',
            labelClassName
          )}
        >
          {label}
        </label>
      )}
      {description && (
        <p id={descriptionId} className="mt-1 text-xs text-gray-400">
          {description}
        </p>
      )}
    </div>
  );

  return (
    <div className={className}>
      <div
        className={classNames(
          'inline-flex gap-2.5',
          description ? 'items-start' : 'items-center',
          labelPosition === 'left' ? 'flex-row-reverse' : 'flex-row'
        )}
      >
        <Toggle
          id={controlId}
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={toggleClassName}
          aria-label={!label ? controlId : undefined}
          aria-labelledby={labelId}
          aria-describedby={descriptionId}
        />
        {labelContent}
      </div>
      {error && <InputError>{error.message}</InputError>}
    </div>
  );
}
